import { render } from "./TabMenu.vue?vue&type=template&id=3f623e94"
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TabMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f623e94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f623e94', __exports__)) {
    api.reload('3f623e94', __exports__)
  }
  
  module.hot.accept("./TabMenu.vue?vue&type=template&id=3f623e94", () => {
    api.rerender('3f623e94', render)
  })

}


export default __exports__